import {
Alert,
InputLabel,
TextField,
FormControl,
FormControlLabel,
FormLabel,
Radio,
RadioGroup,
OutlinedInput,
Typography,
Switch
} from "@mui/material"
import Stack from "@mui/system/Stack";
import ModalContainerModule from "../../../modules/modalContainer"
import {ResponsiveRow} from "../../../../constants/layout.constants"
import {isEmptyArray, isNullUndefined} from "../../../../util/util"
import {setMessage} from "../../../../actions/message"
import {applyIncrement} from "../../../../services/lease.service"
import {useState} from "react"
import {useDispatch} from "react-redux";

export default function IncrementRentModal(props) {
    const [incrementPercentage, setIncrementPercentage] = useState(0)
    const [incrementAmount, setIncrementAmount] = useState(0)
    const [incrementType, setIncrementType] = useState(null)
    const [incrementDeposit, setIncrementDeposit] = useState(false);
    const dispatch = useDispatch()

    function handlePercentageChange(e) {
    setIncrementPercentage(e.target.value)
    }
     function handleAmountChange(e) {
        setIncrementAmount(e.target.value)
        }

      function onRadioChange(radio) {
        const value = radio.target.value;
        if (radio) {
          if (value === "Percentage") {
            setIncrementType(value);
          }
          if (value === "Amount") {
            setIncrementType(value);
          }
        }
      }

        function handleIncrementDepositSwitchToggle(event) {
            setIncrementDeposit(event.target.checked);
          }

    function incrementRent() {
        if (isNullUndefined(incrementType)) {
            dispatch(
                setMessage({
                    type: "error",
                    message:
                        "Increment type is required",
                })
            )
            return
        }

          if (incrementType === "Percentage") {
                    if (isNullUndefined(incrementPercentage)) {
                                      dispatch(
                                          setMessage({
                                              type: "error",
                                              message:
                                                  "Increment percentage is required",
                                          })
                                      )
                                      return
                                  }

                                   if (incrementPercentage <= 0) {
                                                                        dispatch(
                                                                            setMessage({
                                                                                type: "error",
                                                                                message:
                                                                                    "Increment percentage should be greater than zero",
                                                                            })
                                                                        )
                                                                        return
                                                                    }
                }

                          if (incrementType === "Amount") {
                                    if (isNullUndefined(incrementAmount)) {
                                                      dispatch(
                                                          setMessage({
                                                              type: "error",
                                                              message:
                                                                  "Increment amount is required",
                                                          })
                                                      )
                                                      return
                                                  }

                                                   if (incrementAmount <= 0) {
                                                                                        dispatch(
                                                                                            setMessage({
                                                                                                type: "error",
                                                                                                message:
                                                                                                    "Increment amount should be greater than zero",
                                                                                            })
                                                                                        )
                                                                                        return
                                                                                    }
                                }



        let incrementArray = Array.from(props.selectedLeaseIds)
        if (isEmptyArray(incrementArray)) {
            dispatch(
                setMessage({
                    type: "error",
                    message:
                        "You must select at lease one lease to increment",
                })
            )
            return
        }
        let sendData = {
            incrementSet: incrementArray,
            incrementType: incrementType,
            incrementPercentage: incrementPercentage,
            incrementAmount: incrementAmount,
            incrementDeposit: incrementDeposit,
        }

        applyIncrement(sendData)
            .then((response) => {
                if (!isNullUndefined(response)) {
                    dispatch(
                        setMessage({
                            type: response.type,
                            message: response.message,
                        })
                    )
                    props.handleIncrementRentClose()
                }
            })
    }

    return (
        <ModalContainerModule
            size="xs"
            accept={incrementRent}
            cancel={props.handleIncrementRentClose}
            openModal={props.showIncrementRentModal}
            // closeModal
            modalTitle={`Increment rent for ${
                props.selectedLeaseIds && props.selectedLeaseIds.length
            } leases`}
            acceptButtonText={"Apply Increment"}
        >

            <ResponsiveRow container>
              <FormControl
                                                  item
                                                  sx={{
                                                    width: { xs: "100%", lg: "100%" },
                                                    marginBottom: "10px",
                                                  }}
                                                >
                                                  <FormLabel>Increment Type *</FormLabel>

                                                  <RadioGroup
                                                    row
                                                    sx={{ width: "100%" }}
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="use-radio-group"
                                                  >
                                                    <FormControlLabel
                                                      name="radio"
                                                      control={
                                                        <Radio
                                                          checked={incrementType === "Percentage"}
                                                          value="Percentage"
                                                          onClick={onRadioChange}
                                                        />
                                                      }
                                                      label="Percentage"
                                                    />
                                                    <FormControlLabel
                                                      name="radio"
                                                      control={
                                                        <Radio
                                                          checked={incrementType === "Amount"}
                                                          value="Amount"
                                                          onClick={onRadioChange}
                                                        />
                                                      }
                                                      label="Amount"
                                                    />
                                                  </RadioGroup>
                                                </FormControl>


                                                   {
                                                   incrementType === "Percentage" &&
                                                   <FormControl sx={{ width: { xs: "100%", lg: "100%" } }}>
                                                                  <InputLabel>Increment Percentage *</InputLabel>
                                                                  <OutlinedInput
                                                                    label="Increment Percentage"
                                                                    sx={{ width: { xs: "100%", lg: "90%" } }}
                                                                    id={"incrementPercentage"}
                                                                    value={incrementPercentage}
                                                                    disabled={false}
                                                                    type="number"
                                                                    onChange={handlePercentageChange}
                                                                    inputProps={
                                                                      <TextField sx={{ width: { xs: "100%", lg: "90%" } }} />
                                                                    }
                                                                  />
                                                                </FormControl>
                                                                }

                                                                {
                                                                incrementType === "Amount" &&
                                                                <FormControl sx={{ width: { xs: "100%", lg: "100%" } }}>
                                                                                                                                  <InputLabel>Increment Amount *</InputLabel>
                                                                                                                                  <OutlinedInput
                                                                                                                                    label="Increment Amount"
                                                                                                                                    sx={{ width: { xs: "100%", lg: "90%" } }}
                                                                                                                                    id={"incrementAmount"}
                                                                                                                                    value={incrementAmount}
                                                                                                                                    disabled={false}
                                                                                                                                    type="number"
                                                                                                                                    onChange={handleAmountChange}
                                                                                                                                    inputProps={
                                                                                                                                      <TextField sx={{ width: { xs: "100%", lg: "90%" } }} />
                                                                                                                                    }
                                                                                                                                  />
                                                                                                                                </FormControl>
                                                                                                                                }



                   <ResponsiveRow
                                         sx={{
                                           width: "100%",
                                         }}
                                       >
                                       <Alert severity="info">
                                       Click on the toggle button below if there is security deposit increment. Tenants will be invoiced the difference in order to top up the security deposit account.
                                       </Alert>
                                                           <FormControl sx={{ width: { sm: "100%", md: "100%", xl: "100%" }}}>
                                                                                                   <Stack direction="row" spacing={1} alignItems="center">
                                                                                                     <Typography>Increment Deposit</Typography>
                                                                                                     <FormControlLabel
                                                                                                       control={
                                                                                                         <Switch
                                                                                                           checked={incrementDeposit}
                                                                                                           onChange={handleIncrementDepositSwitchToggle}
                                                                                                           inputProps={{ "aria-label": "controlled" }}
                                                                                                         />
                                                                                                       }
                                                                                                     />
                                                                                                   </Stack>
                                                                                                 </FormControl>


                                       </ResponsiveRow>
            </ResponsiveRow>
        </ModalContainerModule>
    )
}